import { Activity, ActivityModel } from "./activities";

export class NavigateToActivityResponse {
  activity: Activity<ActivityModel>;
  canNavigate: boolean;
}
